import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import AdFeesFormContainer from '../../../../Containers/AdminContainer/AdFees/AdfeesForm';
const AdFeesFormScreen = () => {
  return <AdFeesFormContainer />;
};

export default AdFeesFormScreen;
